// ═══════════════════════════════════════════════════════════════════
//  modules/projets/ProjectView.js
//  ProjectView
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { categoriesForProject } from "../chat/utils";
import { CategoryKanban } from "./CategoryKanban";
import { ProjectChat } from "./ProjectChat";

export function ProjectView({ token, projectId, currentUserId, onBack }) {
  const [project, setProject] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const loadProject = useCallback(async () => {
    const res = await fetch(`${API_BASE}/api/projects`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    const found = Array.isArray(data) ? data.find((p) => p.id === projectId) : null;
    setProject(found);
  }, [projectId, token]);

  useEffect(() => {
    loadProject();
    const interval = setInterval(loadProject, 6000);
    return () => clearInterval(interval);
  }, [projectId, loadProject]);

  if (selectedCategory) return <CategoryKanban token={token} projectId={projectId} category={selectedCategory} onBack={() => setSelectedCategory(null)} />;
  if (!project) return <div style={{ color: THEME.textMuted }}>Chargement...</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={onBack} style={{ background: "transparent", border: `1px solid ${THEME.border}`, color: THEME.textMuted, borderRadius: 6, padding: "6px 12px", cursor: "pointer", fontSize: 13 }}>← Tous les projets</button>
        <h2 style={{ color: THEME.gold, fontSize: 20, fontWeight: 800, margin: 0 }}>{project.name}</h2>
        <Badge text={project.status === "actif" ? "Actif" : "Clôturé"} bg={project.status === "actif" ? THEME.emeraldDim : THEME.surface} color={project.status === "actif" ? THEME.emerald : THEME.textMuted} />
      </div>
      <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: "16px 20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
          <span style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 600 }}>PROGRESSION GLOBALE</span>
          <span style={{ color: THEME.gold, fontSize: 13, fontWeight: 700 }}>{project.progress}% ({project.done_tasks}/{project.total_tasks} tâches)</span>
        </div>
        <div style={{ background: THEME.border, borderRadius: 6, height: 10, overflow: "hidden" }}>
          <div style={{ background: THEME.gold, width: `${project.progress}%`, height: "100%", transition: "width 0.4s ease" }} />
        </div>
      </div>
      <div>
        <div style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 600, marginBottom: 10, textTransform: "uppercase" }}>Catégories</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
          {categoriesForProject(project).map(([key, val]) => (
            <button key={key} onClick={() => setSelectedCategory(key)}
              style={{ background: val.bg, border: `1px solid ${val.color}`, color: val.color, borderRadius: 8, padding: "10px 18px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>
              {val.label}
            </button>
          ))}
        </div>
      </div>
      <ProjectChat token={token} projectId={projectId} currentUserId={currentUserId} />
    </div>
  );
}
